import { __decorate } from "tslib";
import { QBtn, QFooter, QHeader, QIcon, QLayout, QPage, QPageContainer, QTab, QTabs, QToolbar, QToolbarTitle, } from 'quasar';
import { Component, Vue } from 'vue-property-decorator';
import DebugButton from '@sicfe/debug/src/components/Button.vue';
import { namespace } from 'vuex-class';
// @ts-expect-error no types available for logo import
import logo from '@/assets/logo-Comforest.svg';
const profileStore = namespace('ProfileStore');
let Base = class Base extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.logo = logo;
    }
    async created() {
        try {
            await this.fetchProfile();
        }
        finally {
            this.loading = false;
        }
    }
    logout() {
        window.location.href = process.env.VUE_APP_CLOUD_LOGOUT_URL;
    }
};
__decorate([
    profileStore.Action('fetch')
], Base.prototype, "fetchProfile", void 0);
__decorate([
    profileStore.State('profile')
], Base.prototype, "profile", void 0);
Base = __decorate([
    Component({
        components: {
            QHeader,
            QIcon,
            QLayout,
            QPage,
            QPageContainer,
            QToolbar,
            QToolbarTitle,
            DebugButton,
            QBtn,
            QTabs,
            QTab,
            QFooter,
        },
    })
], Base);
export default Base;
